import React, { useState, useMemo, useCallback } from 'react';
import Model from '@tripian/model';
import { TripCard, ConfirmModalPopup, TabMenu, Button, PreLoading } from '@tripian/react';
// import { useSelector } from 'react-redux';
import moment from 'moment';
// import ICombinedState from '../../redux/model/ICombinedState';
import './TripList.scss';

interface ITripList {
  tripReferences: Model.TripReference[];
  loadingTripReferences: boolean;
  cardClicked: (tripHash: string) => void;
  cardEditClicked: (tripHash: string) => void;
  cardDeleteClicked: (tripHash: string) => Promise<boolean>;
  tripCreateClicked: () => void;
}

const TripList: React.FC<ITripList> = ({ tripReferences, loadingTripReferences, cardClicked, cardEditClicked, cardDeleteClicked, tripCreateClicked }) => {
  const [modalState, setModalState] = useState({ show: false, tripHash: '' });
  const [isPastTrip, setIsPastTrip] = useState(false);

  const tripReferenceToShow = useMemo(() => {
    const now = moment(new Date()).format('X');
    const tripDate = (datetime: string) => moment(datetime).utcOffset(0).format('X');

    return tripReferences.filter((trip) => {
      const tripDepartureDate = tripDate(trip.trip_profile.departure_datetime);
      return isPastTrip ? tripDepartureDate < now : tripDepartureDate > now;
    });
  }, [isPastTrip, tripReferences]);

  const modalFinally = useCallback(() => {
    setModalState({ show: false, tripHash: '' });
  }, []);

  return (
    <>
      <div className="col col12" style={{ padding: '0 10%' }}>
        <TabMenu
          menuItems={[
            {
              title: 'Upcoming Trips',
              onClick: () => {
                setIsPastTrip(false);
              },
            },
            {
              title: 'Past Trips',
              onClick: () => {
                setIsPastTrip(true);
              },
            },
          ]}
          selectedIndex={0}
        />
      </div>

      {loadingTripReferences ? (
        <PreLoading customClass="py8" />
      ) : (
        <>
          <ConfirmModalPopup
            openModalPopup={modalState.show}
            text="Do you want to delete trip?"
            confirmButtonText="Delete Trip"
            cancelButtonText="Cancel"
            action={() => cardDeleteClicked(modalState.tripHash)}
            confirmationCallback={modalFinally}
            cancelCallback={modalFinally}
          />

          {tripReferenceToShow.length === 0 ? (
            <>
              <div className="col col12 mt5">{isPastTrip ? 'No past trips.' : 'No upcoming trips.'}</div>
              {!isPastTrip ? (
                <div className="col col12 mt5">
                  <Button text="Create A Trip" color="primary" onClick={tripCreateClicked} />
                </div>
              ) : null}
            </>
          ) : (
            tripReferenceToShow.map((tripReference) => (
              <div key={tripReference.id} className="col col12 col6-m">
                <TripCard
                  tripReference={tripReference}
                  clicked={() => cardClicked(tripReference.trip_hash)}
                  editTrip={() => cardEditClicked(tripReference.trip_hash)}
                  deleteTrip={(hash) => {
                    setModalState({ show: true, tripHash: hash });
                  }}
                />
              </div>
            ))
          )}
        </>
      )}
    </>
  );
};

export default TripList;
